<template>
  <div>
     <!-- 列表 -->

      <template>
        <el-table
          :data="list"
          style="width: 100%">
          <el-table-column
            label="客户名称">
            <template slot-scope="scope">
              <div>{{ scope.row.customName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="总计金额">
            <template slot-scope="scope">
              <div>{{ scope.row.totalMount }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="开票税率">
            <template slot-scope="scope">
              <div>{{ scope.row.taxRate }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="开票(含税金额)">
            <template slot-scope="scope">
              <div>{{ scope.row.totalMountTax }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="开票月份">
            <template slot-scope="scope">
              <div>{{ formatime(scope.row.invoiceDate) }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="收款日期">
            <template slot-scope="scope">
              <div>{{ formatime(scope.row.receiveDate) }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="备注">
            <template slot-scope="scope">
              <div>{{ scope.row.remark }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="状态">
            <template slot-scope="scope">
              <div>{{ formatstatus(scope.row.status) }}</div>
            </template>
          </el-table-column>
          <!-- 1，未结算，2已结算3开票4收款 -->
          <el-table-column
            width="320"
            label="操作选项">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleSet('查看', scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="(value) => {return handleSearch(5, value)}"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>

    <!-- 弹框 -->
     <el-dialog
      :title="dialogPara.title"
      :visible.sync="dialogPara.isShowDialog"
      :width="dialogPara.width"
      center>
      <el-form :model="form">
        <!-- 查看 -->
        <template v-if="currentStatus === '查看'">
            <el-form-item label="客户名称">{{ form.customName }}</el-form-item>
            <el-form-item label="总计金额">{{ form.totalMount }}</el-form-item>
            <el-form-item label="开票税率">{{ form.taxRate }}</el-form-item>
            <el-form-item label="开票金额(含税)">{{ form.totalMountTax }}</el-form-item>
            <el-form-item label="发票"><el-button type="primary" size="mini" @click="downloadpdf(form.invoice)" >预览下载</el-button></el-form-item>
            <el-form-item label="备注">{{ form.remark }}</el-form-item>
            <el-form-item label="收款日期">{{ formatime(form.receiveDate) }}</el-form-item>
        </template>

      </el-form>
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPara.isShowDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSucess">确 定</el-button>
      </span>
     </el-dialog>
  </div>
</template>

<script>
import { 
  settlemonthlist, qiniugetDown, dictionariesqueryDictionaryData,
  settlemonthgetInvoiceDetail } from "../../api"
import utils from "../../../public/utils";
export default {
  data () {
    return {
      list: [],
      para: { //  查询条件
        status: '', //  状态
        pageIndex: 1, //  页码
        pageSize: 10 //  每页数量
      },
      dialogPara: { //  弹出框配置
        isshow: false, //  默认不显示参数
        isShowDialog: false, //  默认关闭弹出框
        title: '', //  弹出框标题
        rules: null, //  规则
        width: '50%',
      },
      form: {},
      total: 0,
      currentStatus: '',
      rateList: [], //  税率列表
    }
  },
  mounted() {
    this.getsettlemonthlist()
  },
  methods: {
    handleSet (type, val) {
      this.currentStatus = type
      this.dialogPara.title = type
      this.form = val
       switch (type) {
        case '查看':
          this.getsettlemonthgetInvoiceDetail(val.id)
          this.dialogPara.width = '30%'
          this.dialogPara.isShowDialog = true
          break
        case '开票':
          this.getrate(2)
          this.dialogPara.width = '30%'
          this.dialogPara.isShowDialog = true
          break
       }
    },
    handleSucess () {
      switch (this.currentStatus) {
        case '查看':
          this.dialogPara.isShowDialog = false
          break
      }
    },
    handleSearch (type, val)  {
    },
    getsettlemonthgetInvoiceDetail (id) { //  收款详情
      let para = {
        'id': id
      }
      settlemonthgetInvoiceDetail(para).then(res => {
        console.log(res)
        let { code, data, msg } = res.data
        this.form = data
      })
    },
    getsettlemonthlist () {
      settlemonthlist(this.para).then(res => {
        console.log(res)
        let { code, msg, data } = res.data
        this.list = data.rows
        this.total = data.total
      })
    },
    getrate (did) { //  查询税率列表
      let para = {
        dictionaryId: did
      }
      dictionariesqueryDictionaryData(para).then(res => {
        console.log(res)
        let { code, data, msg } = res.data
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    downloadpdf (w) { // 下载
      console.log(w)
      let res = w.match(/http/g)
      if (res === null) {
        this.$message.error('该链接无效')
      } else {
        let para = new URLSearchParams()
        para.append('baseUrl', w)
        qiniugetDown(para).then(data => {
          console.log(data.data)
          window.open(data.data)
        })
      }
    },
    formatstatus (s) {
      // 0, 1
      switch (s) {
        case 0:
          return '未收款'
        case 1:
          return '已收款'
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.disflexbtw {
  display flex
  justify-content space-between
}
.el-form-item
  display flex
</style>
